<h2 mat-dialog-title class="bg-primary !text-white">Archive order</h2>
<mat-dialog-content>
  <p class="pt-4">
    Are you sure you want to {{ data.isArchived ? 'unarchive' : 'archive' }} order:
    <b>{{ data.order.id }}</b
    >?
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button (click)="onCancel()" [disabled]="isArchiving()">NO</button>
  <button mat-flat-button color="warn" (click)="onConfirm()" [disabled]="isArchiving()">
    <span class="inline-flex items-center gap-2">
      <mat-spinner *ngIf="isArchiving()" diameter="20"></mat-spinner>
      YES
    </span>
  </button>
</mat-dialog-actions>
